import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getInvoice(invoiceId, encoded, index) {
        return Axios.get(`${baseURL}billing/invoice/${invoiceId}`, {
            params: { encoded, index }
        }).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    getInvoices(params) {
        return Axios.get(`${baseURL}billing/invoice`, {
            params: params
        }).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    generatePrintPdf(invoiceId, includeDeclined) {
        return Axios.post(`${baseURL}billing/invoice/pdf`, {
            id: invoiceId,
            include_declined: includeDeclined
        }).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    sendEmail(params) {
        return Axios.post(`${baseURL}billing/invoice/send`, params).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    },
    getInvoiceSMSDetail(invoiceId, params) {
        return Axios.post(
            `${baseURL}billing/invoice/sms/dialog/${invoiceId}`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    sendSMS(invoiceId, params) {
        return Axios.post(
            `${baseURL}communication/invoice/sms/${invoiceId}`,
            params
        ).then(response => response.data.response);
    },
    checkInvoiceRecords(invoiceId) {
        return Axios.post(`${baseURL}billing/invoice/confirmation/destroy`, {
            id: invoiceId
        }).then(response => response.data.response);
    },
    markAsPaid(invoiceId) {
        return Axios.post(`${baseURL}billing/invoice/mark-paid`, {
            invoice_id: invoiceId
        }).then(response => {
            if (response && response.data && response.data.response) {
                return response.data.response;
            }
            return null;
        });
    },
    removeInvoice(invoiceId, params) {
        return Axios.delete(`${baseURL}billing/invoice/${invoiceId}`, {
            params
        }).then(response => {
            if (response && response.data && response.data.response) {
                return response.data.response;
            }
            return null;
        });
    }
};
